class CompaniesUtil {
  getCompanyName(company) {
    return company.name;
  }
}

export const companiesUtil = new CompaniesUtil();
export default new CompaniesUtil();
